










import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import InlineTextEditor, {
  OnSendData,
} from '@/components/InlineTextEditor/InlineTextEditor.vue'
import { SCRIPTS__UPDATE } from '@/store/actions'
import { UserScope } from '@/models/users'

interface Methods {
  [SCRIPTS__UPDATE]: (data: { id: string; title: string }) => Promise<void>
  handleSend: (data: OnSendData) => Promise<void>
}

interface Computed {
  canDoScope: (checkingScope: UserScope) => boolean
  canEditScript: boolean
}

interface Props {
  scriptId: string
  value: string
  editable: boolean
}

export default Vue.extend<{}, Methods, Computed, Props>({
  components: {
    InlineTextEditor,
  },
  props: {
    scriptId: {
      required: true,
    },
    value: {
      required: true,
    },
    editable: {
      default: () => true,
    },
  },
  computed: {
    ...mapGetters(['canDoScope']),
    canEditScript(): boolean {
      return this.editable && this.canDoScope(UserScope.ScriptsEdit)
    },
  },
  methods: {
    ...mapActions([SCRIPTS__UPDATE]),
    async handleSend({ value, resolve, reject }) {
      try {
        await this[SCRIPTS__UPDATE]({
          id: this.scriptId,
          title: value,
        })
        resolve()
      } catch (e) {
        reject()
      }
    },
  },
})
